import { useDownloadableContents } from "@/features/downloadable-content";
import { MagnetBlockCard } from "../ui/MagnetBlockCard";

/**
 * SupportMagnetBlock - 자석블럭 탭 콘텐츠 컴포넌트
 * 다운로드 가능한 콘텐츠 API에서 데이터를 로드합니다
 */
export const SupportMagnetBlock = () => {
  const { data: allContents = [], isLoading } = useDownloadableContents(true);

  // 타입이 'block'인 콘텐츠만 필터링
  const magnetBlocks = allContents.filter(
    (content) => content.content_type === "block"
  );

  return (
    <div className="w-full flex flex-col gap-12 md:gap-14">
      {/* Magnet Block Header */}
      <div className="flex flex-col gap-6">
        <p className="text-lg text-gray-400">고객지원</p>
        <h1 className="text-3xl md:text-4xl font-normal text-black leading-tight">
          자석블럭 도안 다운받기
        </h1>
        <p className="text-base md:text-lg text-black leading-7">
          키워주는 블럭 도안을 자유롭게 다운로드하세요.<br></br>
          단계별 난이도 구성으로 처음 시작하는 아이도 쉽게 따라 만들 수 있어요.
        </p>
      </div>

      {/* Magnet Blocks Grid */}
      <div className="flex flex-col gap-14">
        {/* Loading State */}
        {isLoading && (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
          </div>
        )}

        {/* Magnet Blocks Section */}
        {!isLoading && magnetBlocks.length > 0 && (
          <div className="flex flex-col gap-10 md:gap-14">
            <div className="overflow-x-auto">
              <div className="flex gap-5 min-w-min">
                {magnetBlocks.map((magnetBlock) => (
                  <MagnetBlockCard
                    key={magnetBlock.id}
                    magnetBlock={magnetBlock}
                  />
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Empty State */}
        {!isLoading && magnetBlocks.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500">자석블럭 도안이 없습니다.</p>
          </div>
        )}
      </div>
    </div>
  );
};
